<template>
    <div class="newsList">
        <div class="newsItem" v-for="item in newNewsList" :key="item.id" @click="$emit('itemClick',item.id)">
            <div class="newsIMG">
                <img style="height: 120%;object-fit: cover;" :src="baseUrl + item.image_text">
            </div>
            <div class="newsText">
                <div class="newsTextLeft">
                    <div class="newsTitle">
                        <span>{{item.title}}</span>
                    </div>
                    <div class="newsContent">
                        <span>{{ item.description }}</span>
                    </div>
                </div>
                <div v-if="isShowDate" class="newsTextRight">
                    <div class="date">
                        <span>{{ item.mounth }}月</span>
                        <span>{{ item.day }}</span>
                    </div>
                    <div class="year">
                        {{ item.year }}
                    </div>
                </div>
            </div>
        </div>
        <div class="newsItemMob"  v-for="item in newNewsList" :key="'mob'+item.id" @click="$emit('itemClick',item.id)">
            <div class="newsIMG">
                <img style="height: 120%;object-fit: cover;" :src="baseUrl + item.image_text">
            </div>
            <div class="newsText">
                <div class="newsTitle">
                    <span>{{item.title}}</span>
                    <div class="data" v-if="isShowDate">
                        {{ item.year }}/{{ item.mounth }}/{{ item.day }}
                    </div>
                </div>                
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'newsList',
  props: {
    isHome: {
        type: Boolean,
        default: false
    },
    newsList: {
        type: Array,
        default: () => []
    },
    isShowDate: {
        type: Boolean,
        default: true
    }
  },
  watch: {
    'newsList': function() {
        this.$nextTick(function () {
            this.updateNewsList();
        });
    },
  },
  data() {
    return {
        newNewsList:[],
        baseUrl:window.config.apiUrl,
    }
  },
  methods: {
      updateNewsList(){
        if(this.isHome == true){
            this.newNewsList = this.newsList.slice(0, 3);
        }
        else{
            this.newNewsList = this.newsList.slice(0, 6);
        }
        if(this.isShowDate == false){
            this.$nextTick(function () {
                let newsTextLeftList = document.querySelectorAll('.newsTextLeft');
                for(let i=0;i<newsTextLeftList.length;i++){
                    newsTextLeftList[i].style.width = '100%';
                }
            });            
        }
      },
  },
  mounted() {
    this.$nextTick(function () {
        this.updateNewsList();
    })
  }
}
</script>
<style lang="scss" src="@/assets/css/newsList.scss" scoped></style>